// Rest countdown bar. Auto-starts when a set is logged; sits above the action bar.
// Vibrates on completion (no audio - avoids mobile autoplay restrictions).
import { useEffect, useState } from 'react';

function mmss(sec: number): string {
  const s = Math.max(0, Math.round(sec));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

export function RestTimer({
  endsAt, total, onAdjust, onDismiss,
}: {
  endsAt: number;
  total: number;
  onAdjust: (deltaSec: number) => void;
  onDismiss: () => void;
}) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(t);
  }, []);

  const remaining = (endsAt - now) / 1000;
  const done = remaining <= 0;

  useEffect(() => {
    if (done && typeof navigator !== 'undefined' && navigator.vibrate) navigator.vibrate([120, 60, 120]);
  }, [done]);

  const pct = Math.max(0, Math.min(100, (remaining / total) * 100));

  return (
    <div className="rest-bar" role="timer" aria-live="polite">
      <div className="rest-fill" style={{ width: `${pct}%`, background: done ? 'var(--good)' : 'var(--accent)' }} />
      <div className="rest-inner">
        <button className="btn ghost sm" onClick={() => onAdjust(-30)} aria-label="minus 30 seconds">-30s</button>
        <div className="rest-time">{done ? 'Rest done' : `Rest ${mmss(remaining)}`}</div>
        <button className="btn ghost sm" onClick={() => onAdjust(30)} aria-label="plus 30 seconds">+30s</button>
        <button className="btn sm" onClick={onDismiss}>{done ? 'Go' : 'Skip'}</button>
      </div>
    </div>
  );
}
